import { useEffect, useRef } from "react";

export function useSlideObserver({ index, onActive }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.25) {
            el.classList.add("is-active");
            onActive?.(index);
          } else {
            el.classList.remove("is-active");
          }
        });
      },
      { threshold: [0, 0.25, 0.4, 0.6, 0.8, 1] }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [index, onActive]);

  return ref;
}

